import { Box } from "@mui/system";
import React from "react";

import EditProfileImageUploader from "../../../../components/EditProfile/ProfilePicture/EditProfileImageUploader";
import AvatarSelector from "../../../../components/EditProfile/ProfilePicture/AvatarSelector";
import UseWindowDimensions from "../../../../../utils/windowSize";
import CustomHelmet from "../../../../components/CustomHelmet";

const EditProfilePicture = () => {
  const { height } = UseWindowDimensions();

  return (
    <>
      <CustomHelmet title={`Edit avatar | Profile`} />
      <Box
        sx={{
          height: height + "px",
          overflowY: "auto",
          backgroundColor: "white.main",
        }}
      >
        <EditProfileImageUploader />
        <AvatarSelector />
      </Box>
    </>
  );
};

export default EditProfilePicture;
